<template>
  <li
    class="oct-tab-item"
    role="tab"
    :aria-selected="selected ? 'true' : selected"
  >
    {{ text }}
    <slot />
  </li>
</template>

<script>
export default {
  name: 'OctTabItem',
  props: {
    /** Text */
    text: {
      type: String,
      default: ''
    },
    /** Whether selected */
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-tab-item {
  font-size: oct-rem(16);
  font-weight: 600;
  color: $oct-theme--neutral-50;
  line-height: 1;
  display: flex;
  padding: oct-rem(24) oct-rem(32) oct-rem(18);
  border-bottom: oct-rem(6) solid transparent;
  cursor: pointer;

  &[aria-selected="true"] {
    color: $oct-theme--neutral;
    border-bottom-color: $oct-theme--neutral;
  }
}
</style>